export default "/vendor/ie11CustomProperties.js";